import APILibrary, { ClassExtender, GConstructor, GenerateResource } from './APILibrary';
import { Base } from 'active-resource';
import { GeographyResource } from './Geography';

/**
 * Relationship classes
 */
export class HiringHeroConfigAttributes {
  configType: string = null;
  value: number = null;
}

export class HiringHeroConfigBelongsTo {
  geography: () => GeographyResource = () => new GeographyResource();
}

export class HiringHeroConfigHasOne {}

export class HiringHeroConfigHasMany {}

/**
 * Utility interfaces
 */
export interface HiringHeroConfigMethods {}

export interface HiringHeroConfigInterface
  extends HiringHeroConfigAttributes,
    HiringHeroConfigBelongsTo,
    HiringHeroConfigHasOne,
    HiringHeroConfigHasMany,
    HiringHeroConfigType {}

type HiringHeroConfigType = GConstructor<HiringHeroConfigInterface>;

export interface HiringHeroConfigResource
  extends Base<HiringHeroConfigAttributes>,
    HiringHeroConfigInterface,
    HiringHeroConfigMethods {}

/**
 * Resource methods
 */
const BaseClass = () =>
  GenerateResource<HiringHeroConfigAttributes>({
    queryName: 'hiring_hero_config',
    className: 'HiringHeroConfig',
    AttributesClass: HiringHeroConfigAttributes,
    BelongsToClasses: [
      {
        Klass: HiringHeroConfigBelongsTo,
      },
    ],
    HasOneClasses: [
      {
        Klass: HiringHeroConfigHasOne,
      },
    ],
    HasManyClasses: [
      {
        Klass: HiringHeroConfigHasMany,
      },
    ],
  });

export const HiringHeroConfigResourceClass = <TBase extends HiringHeroConfigType>(
  BaseConstructor: TBase,
) => class extends BaseConstructor implements HiringHeroConfigMethods {};

export class HiringHeroConfigResource extends ClassExtender<HiringHeroConfigInterface>(
  BaseClass,
  HiringHeroConfigResourceClass,
) {}

/**
 * Resource instance
 */
export const HiringHeroConfig =
  APILibrary.createResource<HiringHeroConfigResource>(HiringHeroConfigResource);
